import { ConceptNodeMap } from "../../Concepts.interface";
import { getAllDescendants } from "./getAllDescendants";
import { isAncestorSelected } from "./isAncestorSelected";

export const compressImplicitSelection = (
  selected: Set<string>,
  treeMap: ConceptNodeMap,
) => {
  let changed = true;
  let currentSet = new Set(selected);

  while (changed) {
    changed = false;
    const nextSet = new Set(currentSet);

    for (const id of currentSet) {
      const node = treeMap[id];
      if (!node?.parentId) continue;

      const parent = treeMap[node.parentId];
      if (!parent) continue;

      const allSiblingsSelected = parent.children.every((child) =>
        currentSet.has(child.id),
      );

      if (allSiblingsSelected) {
        getAllDescendants(parent.id, treeMap).forEach((descId) =>
          nextSet.delete(descId),
        );

        if (!isAncestorSelected(parent.id, currentSet, treeMap)) {
          nextSet.add(parent.id);
          changed = true;
        }
      }
    }

    currentSet = nextSet;
  }

  return currentSet;
};
